<template>
    <div class="preset-picker">
        <h3 class="preset-picker__title"><i class="fas fa-magic text-primary me-2"></i> Quick Start Templates</h3>
        <p class="preset-picker__subtitle">Choose a preset to apply instantly, or customize your own below.</p>
        <div class="preset-picker__grid">
            <div
                v-for="preset in presets"
                :key="preset.id"
                class="preset-card"
                :class="{ 'preset-card--active': activePresetId === preset.id }"
                @click="selectPreset(preset)"
            >
                <div class="preset-card__swatches">
                    <span class="swatch swatch--nav" :style="{ background: preset.colors.top_navbar }"></span>
                    <span class="swatch swatch--sidebar" :style="{ background: preset.colors.sidebar_navbar }"></span>
                    <span class="swatch swatch--primary" :style="{ background: preset.colors.primary_button }"></span>
                    <span class="swatch swatch--bottom" :style="{ background: preset.colors.bottom_navbar }"></span>
                </div>
                <div class="preset-card__info">
                    <span class="preset-card__name">{{ preset.name }}</span>
                    <span class="preset-card__desc">{{ preset.description }}</span>
                </div>
                <div v-if="activePresetId === preset.id" class="preset-card__check">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.3 4.7L6.5 11.5L2.7 7.7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { themePresets } from '@/config/themePresets';

export default {
    name: 'OThemePresetPicker',
    props: {
        /** Currently active preset ID (matched by comparing colors) */
        activePresetId: {
            type: String,
            default: null,
        },
    },
    emits: ['select'],
    setup(props, { emit }) {
        const presets = themePresets;

        const selectPreset = (preset) => {
            emit('select', preset);
        };

        return { presets, selectPreset };
    },
};
</script>

<style scoped>
.preset-picker {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.preset-picker__title {
    font-size: 15px;
    font-weight: 600;
    color: #1B1E28;
    margin: 0;
}

.preset-picker__subtitle {
    font-size: 13px;
    color: #717784;
    margin: 0;
    margin-top: -8px;
}

.preset-picker__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

@media (max-width: 768px) {
    .preset-picker__grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

.preset-card {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px;
    border: 2px solid #E1E4EA;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #FFFFFF;
}

.preset-card:hover {
    border-color: #C4C9D4;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.preset-card--active {
    border-color: var(--primary-color, #F93E3E);
    background: #FEFEFE;
    box-shadow: 0 0 0 3px var(--secondary-color, rgba(249, 62, 62, 0.1));
}

.preset-card__swatches {
    display: flex;
    gap: 4px;
    height: 28px;
    border-radius: 6px;
    overflow: hidden;
}

.swatch {
    flex: 1;
    border-radius: 4px;
}

.preset-card__info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.preset-card__name {
    font-size: 13px;
    font-weight: 600;
    color: #1B1E28;
}

.preset-card__desc {
    font-size: 11px;
    color: #717784;
    line-height: 1.3;
}

.preset-card__check {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--primary-color, #F93E3E);
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
